// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { TenantAuthen } from 'util/Enums';
import styles from './TenantAuthen.module.scss';
import Html5QrcodePlugin from 'components/molecules/Html5QrcodePlugin';
import ScanICCardPlugin from 'components/molecules/ScanICCardPlugin';
import { useScanICBarcode } from 'util/hooks/useScanICBarcode';

const TennantAuthenPage: React.FC = () => {
  const user = useSelector(selectUser);

  const { onNewScanBarcode, onNewScanICCard } = useScanICBarcode();

  return (
    <div className={styles.tenantAuthen}>
      {user.tenantAuthen === TenantAuthen.Barcode && (
        <Html5QrcodePlugin
          fps={10}
          qrbox={{ width: 250, height: 250 }}
          disableFlip={false}
          qrCodeSuccessCallback={onNewScanBarcode}
        />
      )}
      {user.tenantAuthen === TenantAuthen.ICCard && (
        <ScanICCardPlugin onScanSuccess={onNewScanICCard} />
      )}
    </div>
  );
};

export default TennantAuthenPage;
